import { FC, Fragment, useCallback, useState } from "react";
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuProps,
  PopoverOrigin,
} from "@mui/material";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import InsertChartOutlinedOutlinedIcon from "@mui/icons-material/InsertChartOutlinedOutlined";

import { DashboardCreateFolderOrItemDialog } from "./create-folder-or-item-dialog/DashboardCreateFolderOrItemDialog";
import { NavigationHierarchyItemType } from "../../../../../store/navigation/utils/types";

interface DashboardV2NavigationAddActionMenuProps {
  open: boolean;
  onCloseMenu(): void;
  anchorEl: MenuProps["anchorEl"];
}

export const DashboardV2NavigationAddActionMenu: FC<
  DashboardV2NavigationAddActionMenuProps
> = ({ open, onCloseMenu, anchorEl }) => {
  const [dialogType, setDialogType] = useState<
    NavigationHierarchyItemType | undefined
  >();

  const itemClickHandler = useCallback(() => {
    setDialogType("item");
  }, []);

  const folderClickHandler = useCallback(() => {
    setDialogType("folder");
  }, []);

  const closeDialog = useCallback(() => {
    setDialogType(undefined);
    onCloseMenu();
  }, [onCloseMenu]);

  return (
    <Fragment>
      <Menu
        open={open}
        onClose={onCloseMenu}
        anchorEl={anchorEl}
        disablePortal={false}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        <MenuItem onClick={itemClickHandler}>
          <ListItemIcon>
            <InsertChartOutlinedOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Dashboard</ListItemText>
        </MenuItem>

        <MenuItem onClick={folderClickHandler}>
          <ListItemIcon>
            <FolderOpenIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Folder</ListItemText>
        </MenuItem>
      </Menu>

      {dialogType && (
        <DashboardCreateFolderOrItemDialog
          onClose={closeDialog}
          type={dialogType}
        />
      )}
    </Fragment>
  );
};

const anchorOrigin: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};

const transformOrigin: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};
